import {sha256} from "js-sha256";

export const obtenerSha = (texto) =>{

    let procesado = texto.toLowerCase()

    return sha256(procesado)


}